import React from 'react';
import PropTypes from 'prop-types';

import { Text } from '../Elements';

import classes from './TitleAdditional.module.scss';

const TitleAdditional = ({ data }) => {
  return (
    <Text className={classes.text} weight="b">
      &nbsp;{data}
    </Text>
  );
};

TitleAdditional.propTypes = {
  data: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default TitleAdditional;
